import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_site_unblock.component.html'
})
export class SetSiteUnBlockModalComponent extends BaseSupportModalComponent {
	title: string;
	siteId: string;
	userEmail: string;
	domainUrl: string;
	message: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите разблокировать сайт ${this.domainUrl}?`)) {
			await this.supportService.setSiteUnBlock(this.siteId, this.message, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
